import { useEffect, useMemo } from 'react';
import { StockDocumentSchema } from 'types/clientV2/stockDocuments';
import { StockDocument } from 'types/inventory';
import { PublicPartAssetSchema } from 'types/clientV2/parts';

export const useGetDocumentTempURL = ({
  documentBlob,
  selectedDocument,
}: {
  documentBlob: string | Blob | ArrayBuffer | ArrayBufferView | undefined;
  selectedDocument:
    | StockDocument
    | StockDocumentSchema
    | PublicPartAssetSchema
    | undefined;
}) => {
  const documentTempURL = useMemo(
    () =>
      documentBlob
        ? window.URL && window.URL.createObjectURL
          ? window.URL.createObjectURL(
              new Blob([documentBlob as Blob], {
                type: selectedDocument?.mimeType || 'application/pdf',
              })
            )
          : window.webkitURL.createObjectURL(
              new Blob([documentBlob as Blob], {
                type:
                  selectedDocument && 'mimeType' in selectedDocument
                    ? selectedDocument.mimeType || 'application/pdf'
                    : 'application/pdf',
              })
            )
        : null,
    [documentBlob, selectedDocument]
  );

  useEffect(
    () => () => {
      if (documentTempURL) {
        URL.revokeObjectURL(documentTempURL);
      }
    },
    [documentTempURL]
  );

  return documentTempURL;
};
